/**
 * Паралельна обробка з обмеженням одночасних викликів (чиста утиліта): не більше `limit` обіцянок водночас, результати — у порядку входу.
 * Масові запити (визначення всіх модулів) не мають перевантажувати сервер і пул підключень до бази.
 */
export async function mapLimited<T, R>(items: readonly T[], limit: number, fn: (item: T) => Promise<R>): Promise<R[]> {
  const out: R[] = new Array<R>(items.length);
  let next = 0;
  const worker = async () => {
    while (next < items.length) {
      const i = next;
      next += 1;
      out[i] = await fn(items[i]!);
    }
  };
  await Promise.all(Array.from({ length: Math.max(1, Math.min(limit, items.length)) }, worker));
  return out;
}
